import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagLogo = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagLogo'>
      {({ field }) => (
        <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagLogo' label='Compania Logo' />
      )}
    </Field>
  )
}

export default React.memo(FlagLogo)
